module.exports = __webpack_public_path__ + "img/coinbankB07.c5f90974.jpg";